import React, { ReactElement, useState } from 'react'
import { Fab, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import BackButton from '../../../components/_WMS/BackButton/BackButton'
import { useStepper } from '../../../hooks'
import { StepProps } from './types'

interface StepperShellProps<T> {
  steps: ((props: StepProps<T>) => ReactElement)[]
  initialSharedState?: T
  backButtonWithText?: boolean
}

export const StepperShell = <T,>({
  steps,
  initialSharedState,
  backButtonWithText = false  
}: StepperShellProps<T>) => {
  const {
    currentStep,
    next,
    prev,
    goToStep,
    isFirstStep,
    isLastStep,
    priorStep
  } = useStepper({ steps: steps.length })

  const [sharedState, setSharedState] = useState<T>(initialSharedState as T)

  const CurrentStepComponent = steps[currentStep]({
    currentStep,
    next,
    prev,
    goToStep,
    isFirstStep,
    isLastStep,
    sharedState,
    setSharedState,
    priorStep
  })

  const showBack = !isFirstStep && !(sharedState as any)?.hideBackButton
  const stepTitle = (sharedState as any)?.stepTitle
  
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '92%',
        width: '100%',
        backgroundColor: '#FFF'
      }}
    >
      {stepTitle && (
        <div style={{ padding: '12px 16px 4px 16px', flexShrink: 0 }}>
          <Typography variant='body2' sx={{ fontWeight: 500, color: '#333' }}>
            {stepTitle}
          </Typography>
        </div>
      )}
      {showBack && (
        backButtonWithText ? (
          <div style={{ padding: '6px 6px 0 6px', flexShrink: 0 }}>
            <Fab
              variant='extended'
              size='medium'
              onClick={prev}
              style={{
                borderRadius: '12px',
                height: '40px',
                paddingLeft: '10px',
                paddingRight: '14px',
                backgroundColor: 'transparent',
                border: '1px solid #E0E0E0',
                boxShadow: 'none',
                gap: '6px',
                fontSize: '14px',
                fontWeight: 500,
                color: '#666',
                textTransform: 'none'
              }}
            >
              <ArrowBackIcon style={{ fontSize: 18, color: '#1976d2' }} />
              Volver
            </Fab>
          </div>
        ) : (
          <BackButton onClick={prev} />
        )
      )}
      <div style={{ flex: 1, overflow: 'auto' }}>
        {CurrentStepComponent}
      </div>
    </div>
  )
}
